"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchBox = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _reactIntl = require("react-intl");
var _constants = require("../../constants");
var _AuInput = _interopRequireDefault(require("./AuInput"));
var _Spinner = _interopRequireDefault(require("./Spinner"));
var _context, _context2, _context3, _context4;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "search_box-module__container___FFspP",
  "input": "search_box-module__input___ByZtn",
  "empty": "search_box-module__empty___mNSWQ",
  "disabled": "search_box-module__disabled___TgCKT",
  "clear": "search_box-module__clear___UYaKY",
  "loading": "search_box-module__loading___wPMfr",
  "spinner": "search_box-module__spinner___k884a"
};
const debounceOptions = (0, _freeze.default)({
  leading: false,
  trailing: true
});
class SearchBox extends _react.default.Component {
  static propTypes = {
    className: T.string,
    value: T.string,
    disabled: T.bool,
    disabledHint: T.string,
    debounce: T.number,
    onChange: T.func,
    onFocus: T.func,
    onBlur: T.func,
    placeholderId: T.string,
    placeholder: T.string,
    loading: T.bool
  };
  static defaultProps = {
    value: '',
    disabled: false,
    debounce: 100,
    onChange: _constants.NOOP,
    onFocus: _constants.NOOP,
    onBlur: _constants.NOOP,
    placeholder: '',
    loading: false
  };
  state = {
    value: this.props.value
  };
  setValue = (0, _bind.default)(_context = this.setValue).call(_context, this);
  setValue(value, callback) {
    this.setState({
      value
    }, () => typeof callback === 'function' && callback(value));
  }
  handleOnChange = (0, _bind.default)(_context2 = this.handleOnChange).call(_context2, this);
  handleOnChange(e) {
    this.setValue(e.target.value, this.notify);
  }
  onClearBtnClick = (0, _bind.default)(_context3 = this.onClearBtnClick).call(_context3, this);
  onClearBtnClick() {
    this.setValue('', this.props.onChange);
  }
  notify = (0, _bind.default)(_context4 = (0, _debounce.default)(this.notify, this.props.debounce, debounceOptions)).call(_context4, this);
  notify() {
    this.props.onChange(this.state.value);
  }
  render() {
    const {
      className,
      disabled,
      disabledHint,
      intl,
      onFocus,
      onBlur,
      loading
    } = this.props;
    const {
      value
    } = this.state;
    const placeholder = this.props.placeholderId && intl.formatMessage({
      id: this.props.placeholderId
    }) || this.props.placeholder;
    const empty = value === '';
    const classNames = (0, _classnames.default)(styles.input, {
      [styles.empty]: empty,
      [styles.disabled]: disabled,
      [styles.loading]: loading
    });
    let title;
    if (disabled && disabledHint) {
      title = disabledHint;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className),
      title: title
    }, /*#__PURE__*/_react.default.createElement(_AuInput.default, {
      type: "text",
      name: "searchbox_text",
      className: classNames,
      placeholder: placeholder,
      onChange: this.handleOnChange,
      onClear: this.onClearBtnClick,
      onFocus: onFocus,
      onBlur: onBlur,
      value: value,
      disabled: disabled,
      loading: loading,
      showClear: !loading
    }), !empty && loading && /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      className: styles.spinner
    }));
  }
}
exports.SearchBox = SearchBox;
var _default = (0, _reactIntl.injectIntl)(SearchBox);
exports.default = _default;